import { EntityType } from '../../models/entity.model';

export type GroupIconName = (typeof GROUP_ICON)[keyof typeof GROUP_ICON];

export type FgaIconName = EntityType | GroupIconName;

export const GROUP_ICON = {
  LOCAL: 'local-group',
  SCIM: 'scim-group',
} as const;
